type TransitionDurationInternal = string[] & {
  fast?: string;
  normal?: string;
  slow?: string;
  slowest?: string;
};

type TransitionDuration = Required<TransitionDurationInternal>;

const transitionDuration: TransitionDurationInternal = [
  '150ms',
  '300ms',
  '450ms',
  '600ms',
];

transitionDuration['fast'] = transitionDuration[0];
transitionDuration['normal'] = transitionDuration[1];
transitionDuration['slow'] = transitionDuration[2];
transitionDuration['slowest'] = transitionDuration[3];

export default transitionDuration as TransitionDuration;
